import { addToast } from "./addToast";
import { removeToast } from "./removeToast";
import { removeBatch } from "./removeBatch";

export const reducers = {
    addToast,
    removeToast,
    removeBatch,
};
